import { Map as ImmutableMap } from 'immutable';
import { createSelector } from 'reselect';
const getManageTable = state => state.getIn(['manage', 'table'], ImmutableMap({}));
export const getSelectedEmailRows = createSelector([getManageTable], table => table.get('selectedEmailRows'));
export const getLastSelectedActionPopoverId = state => {
  return state.getIn(['manage', 'frameworkTable']).lastSelectedActionPopoverId;
};
export const getSelectedEmail = createSelector([getManageTable], table => table.get('selectedEmail'));